import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export default function ThemeColorPresets({ children }: Props) {
  return <>{children}</>;
}
